<div class="pcn-details">
  <div
    class="left-container"
    [ngClass]="{
      opened: this.global.isPcnPanelLocked,
      closed: !this.global.isPcnPanelLocked
    }"
  >
     <pcn-block></pcn-block>
  </div>

  <div
    class="right-container"
    [ngClass]="{
      opened: this.global.isPcnPanelLocked,
      closed: !this.global.isPcnPanelLocked
    }"
  >
    <div class="reasons" #reasonsContainer>
      <div class="pcn-lock-block" *ngIf="global.isReasonsLocked">
        <img class="lock" src="assets/img/icons/lock-purple-mid.svg" />
      </div>
      <div class="reasons-helper" (click)="selectLetterLayout($event.target)">
        <div class="reasons-full-container">
          <div *ngIf="isNexusEnabled">
            <app-nexus-upload></app-nexus-upload>
          </div>    
          <reasons (onScrollToQuestions)="scrollToQuestions()"></reasons>
          <div #questionsBlock>
            <ng-container *ngIf="questionsVisible">
              <documents-questions *ngIf="!isCustomLettersVisible && !isCustomParagraphsVisible"></documents-questions>
            </ng-container>
          </div>
          <custom-letters *ngIf="isCustomLettersVisible"></custom-letters>
          <custom-paragraphs *ngIf="isCustomParagraphsVisible"></custom-paragraphs>
        </div>
      </div>
    </div>
    
    <div
      class="letter"
      [ngClass]="{
        active: !isReasonsLayoutVisible,
        opened: isLetterPanelVisible
      }"
    >
      <div
        class="letter-helper"
        (click)="selectReasonsLayout($event.target)"
        [ngClass]="{ opened: isLetterPanelVisible }"
      >
        <letter></letter>
      </div>
    </div>
  </div>
</div>
